Jelly.Interface.Scroll_To = function(Parameters) {
	if (Parameters.$)
		$Animate_Element = Parameters.$;
	else
		$Animate_Element = $(Parameters.Element);

	do_scroll = false;
	if (!Parameters.hasOwnProperty('Direction'))
		do_scroll = true;
	else {
		if (Parameters.Direction == 'down' && $Animate_Element.scrollTop() < Parameters.To)
			do_scroll = true;	
		if (Parameters.Direction == 'up' && $Animate_Element.scrollTop() < Parameters.To)
			do_scroll = true;	
	}

	if (do_scroll) {
		$Animate_Element.animate({
					scrollTop: Parameters.To,
				}
			,	(Parameters.Duration ? Parameters.Duration : 400)
			, 'swing'
			, function () {if (Parameters.Then) {Parameters.Then();}}
		);
	}
};